import React from "react";
import { useState } from "react";
import "./Card.css";
import icon from "./images/icon-cart.svg";
export const AddToCard = () => {
  const [isAddedTocart, setIsAddedToCart] = useState(false);
  const handleAddToCart = () => {
    setIsAddedToCart(true);
  };

  return (
    <>
      <button onClick={handleAddToCart} id="add-to-card">
        <img src={icon} alt="shopping-cart" id="icon" />
        {isAddedTocart ? "Added to Cart" : "Add to Cart"}
      </button>
    </>
  );
};
